import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { PolicyStatusEnum } from '../enums/policy-status.enum';
import { PolicyTypeEnum } from '../enums/policy-type.enum';

/**
 * Policies filters
 */
export class PoliciesFilters extends ApiRequestFilters {
	/**
	 * Policy type values
	 */
	types?: PolicyTypeEnum[];

	/**
	 * Status values
	 */
	statuses?: PolicyStatusEnum[];

	/**
	 * Filter policies applicable to subject
	 */
	applicableToSubject?: AppSubjectEnum;
}
